import React from "react";
import { View, Image } from "react-native";

import { Background, Card } from "components";

import { styles } from "./styles";

const notFoundImage = require("assets/images/not-found.png");

const NotFound = () => (
  <Background style={styles.background}>
    <Card style={styles.card}>
      <View style={styles.container}>
        <Image
          style={styles.image}
          resizeMode="contain"
          source={notFoundImage}
        />
      </View>
    </Card>
  </Background>
);

export default NotFound;
